module.exports = __webpack_public_path__ + "img/expressOld.bddd830f.png";